$(document).ready(function() {  

  $($('.subify-choice-box-wrapper')[0]).hide();

  
//   2021-06-28
//   hide empty search message!
  $('p:contains("Your search for \"\" revealed the following:")').hide()


  $.shifter({
    maxWidth: "740px"
  });  

  // Call Fancybox globally on all elements with class fancybox
  $(".fancybox").fancybox({
    helpers: {
      overlay: {
        locked: false
      }
    }
  }); 
  

  $('.flexslider').flexslider({
    animation: "fade",
    controlNav: false,
    slideshowSpeed: 5000,
    directionNav: true
  });
  
  $('.flexslider-new-arrivals').flexslider({
//     animation: "fade",
//     controlNav: false,
//     slideshowSpeed: 5000,
//     directionNav: true
      'selector': '.slides-new-arrivals'
  });
  
  

  

  //<![CDATA[
  jQuery(function() {
    jQuery('#sidebar ul li a').each(function() {
      if (jQuery(this).attr('href')  ===  window.location.pathname) {
        jQuery(this).addClass('current');
      }
    });
  });  
  //]]>


}); 

   
